import { DataApiResponse } from '../../../contract/base/Response';
import { User } from '../../../contract/identity/User';
import axiosInstance from '../../../utils/axios';
import { handleError } from '../../base/baseService';

type CreatePhoneNumberVerificationTokenRequest = {
  phoneNumber: string;
};

export async function createPhoneNumberVerificationToken(request: CreatePhoneNumberVerificationTokenRequest) {
  try {
    const response = await axiosInstance.post<DataApiResponse<User>>('/users/self/phone-confirmation-token', request);

    return response.data;
  }
  catch (error) {
    return handleError(error);
  }
}